import { render } from "./FarmCropImage.vue?vue&type=template&id=4be89680&scoped=true&ts=true"
import script from "./FarmCropImage.vue?vue&type=script&lang=ts"
export * from "./FarmCropImage.vue?vue&type=script&lang=ts"

import "./FarmCropImage.vue?vue&type=style&index=0&id=4be89680&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be89680"]])

export default __exports__